import Navbar from "../components/Navbar";
import Hero from "../Hero";
import Courses from "../Courses";
import Why from "../Why";
import Testimonials from "../Testimonials";
import CTA from "../CTA";
import Footer from "../Footer";
import LeadForm from "../LeadForm";

function Home() {
  return (
    <>
  <div className="top-banner">
    <div className="top-banner-track">

      🚀 Founding Batch 2026 Now Open •
      Limited Seats Available •
      Frontend Development Career Program •
      Classes Starting Soon •
      1 Week Free Demo •

    </div>
  </div>

  <Navbar />
  <Hero />
      
  <section id="courses" className="programs-section">

  <div className="programs-wrapper">

    <div className="new-programs-grid">

      {/* FRONTEND PROGRAM */}

      <div className="frontend-card">

        <span className="program-badge blue-badge">
          LIVE + PROJECT BASED
        </span>

        <h3>
          Frontend Development
          <br />
          Career Program
        </h3>

        <p>
          Master modern frontend development with React,
          JavaScript, responsive UI design, Git, APIs,
          debugging, deployment, and real-world project building.
        </p>
        <div className="mini-tags">
  <span>1 WEEK FREE DEMO</span>
  <span>BEGINNER FRIENDLY</span>
  <span>JOB READY</span>
</div>

        <div className="program-features">

          <div>✓ React + JavaScript</div>
          <div>✓ Git & GitHub</div>

          <div>✓ Real Projects</div>
          <div>✓ Resume Guidance</div>

          <div>✓ Portfolio Building</div>
          <div>✓ Interview Preparation</div>

        </div>

        <div className="program-bottom">

          <div>

            <span className="program-label">
              Program Fee
            </span>

            <h4>₹19,999</h4>

          </div>

          <div className="program-duration">

            <span>Duration</span>

            <strong>8–10 Weeks</strong>

          </div>

        </div>

        <button
  className="program-btn"
  onClick={() => window.location.href="/pricing"}
>
  Start Learning
</button>

      </div>

      {/* FULL STACK TRAINEE */}

      <div className="trainee-card">

        <span className="program-badge yellow-badge">
          COMING SOON
        </span>

        <h3>
          Full Stack Developer
          <br />
          Trainee Program
        </h3>

        <p>
          An advanced career-track program combining full stack
          development, production projects, mentorship,
          and internship-style trainee experience.
        </p>
        <div className="mini-tags trainee-tags">
  <span>INTERNSHIP STYLE</span>
  <span>REAL STARTUP PROJECTS</span>
  <span>CAREER TRACK</span>
</div>

        <div className="program-features">

          <div>✓ Frontend + Backend + Database</div>
          <div>✓ Internship Style Training</div>

          <div>✓ Real Startup Projects</div>
          <div>✓ Code Reviews & Mentorship</div>

          <div>✓ Team Collaboration</div>
          <div>✓ Certificate & Career Support</div>

        </div>

        <div className="trainee-highlight">

          Includes trainee + internship style experience
          with mentorship benefits.

        </div>

        <button
  className="program-btn trainee-btn"
  onClick={() => alert("Waitlist opening soon!")}
>
  Join Waitlist
</button>

      </div>

    </div>

  </div>

</section>


      <Why />
      <Testimonials />

      

      {/* 🔥 URGENCY / FOUNDING BATCH SECTION */}
      <section className="pricing-urgency">
        <div className="urgency-box">

          <span className="urgency-badge">🚀 Founding Batch – 2026</span>

          <h2>Become a Founding Learner 🚀</h2>

          <p>
            Join our first batch and help shape the future of CODEION.
            Get personalized attention, early access benefits, and direct mentorship.
          </p>

          <div className="urgency-points">
            <div>✅ Limited seats for focused learning</div>
            <div>✅ Direct interaction with mentors</div>
            <div>✅ Early learner benefits (discounts / bonuses)</div>
            <div>✅ Opportunity to influence course structure</div>
            <div>⚠️ Prices will increase after this batch</div>
          </div>

          <button
            className="primary"
            onClick={() => window.location.href = "/pricing"}
          >
            View Pricing
          </button>

        </div>
      </section>

      <CTA />

      {/* 🔥 LEAD CAPTURE FORM */}
      <LeadForm />

      <Footer />
    </>
  );
}

export default Home;